// extracted by mini-css-extract-plugin
export var aircallIframe = "_lj-3";
export var fabContainer = "_lj-5";
export var fabRinging = "_lj-6";
export var loadingOverlay = "_lj-4";
export var pulse = "_lj-7";
export var widgetContent = "_lj-2";
export var widgetPanel = "_lj-0";
export var widgetPanelExpanded = "_lj-1";